export default {
  SHOW_LYRIC: 'SHOW_LYRIC',
  SHOW_OVERLAY: 'SHOW_OVERLAY',
  ACTIVE_LYRIC: 'ACTIVE_LYRIC',
  ACTIVE_OVERLAY: 'ACTIVE_OVERLAY'
}



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/